import { getToken } from './utils/helpers';

const __WEBSOCKET_HOST__ = typeof window === 'undefined' || window.WEBSOCKET_HOST;

let socket = null;
let currentToken = null;
let subscriptions = {};


function subscribe(channel, callback) {
    socket.removeAllListeners(channel);
    socket.on(channel, payload => callback(JSON.parse(payload)));

    if (!subscriptions[channel]) {
        socket.emit('subscribe', channel);
        subscriptions[channel] = true;
    }
}

function unsubscribe(channel) {
    socket.removeAllListeners(channel);

    if (subscriptions[channel]) {
        socket.emit('unsubscribe', channel);
        delete subscriptions[channel];
    }
}

let isAuthenticated = false;
function authenticate({ force }) {
    let token = getToken();

    if (!socket) {
        return;
    }

    if (!force && token === currentToken) {
        return;
    }

    if (isAuthenticated) {
        // socket.io.reconnect() is not working correctly
        socket.io.disconnect();
        socket.io.connect();
        return;
    }

    socket.emit('auth', token, response => {
        if (response.status !== 'ok') {
            return;
        }

        isAuthenticated = true;
        currentToken = token;

        for (let channel of Object.keys(subscriptions)) {
            socket.emit('subscribe', channel);
        }
    });
}

export default new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
        reject('WebSocket is not working in Node environment');
    }

    // currentToken is set after successful authentication
    if (currentToken) {
        return resolve(socket);
    }

    let script = document.createElement('script');

    script.onload = function () {
        if (!window.io) {
            reject('socket.io doesn\'t exists.');
        }

        socket = window.io( __WEBSOCKET_HOST__, { transports: [ 'websocket', 'polling' ] } );

        socket.subscribe = subscribe;
        socket.unsubscribe = unsubscribe;

        socket.on('connect', () => authenticate({ force: true }));
        socket.on('disconnect', () => isAuthenticated = false);
        socket.on('auth', () => resolve(socket));

        setInterval(() => authenticate({ force: false }), 30 * 1000);
    };

    script.onerror = function (err) {
        reject(err);
    };

    script.src = __WEBSOCKET_HOST__ + '/socket.io/socket.io.js';
    document.body.appendChild(script);
});
